define('helpers/i18nHelper',['i18n', 'env'], function (i18n, Config) {
    var DEFAULT_LANG = 'es',
            COOKIE_NAME = 'md_i18next',
            currentLang = DEFAULT_LANG,
            appLangs = ['es', 'en', 'it', 'pt', 'fr'];

    var getI18nConfig = function () {
        return {
            fallbackLng: DEFAULT_LANG,
            useDataAttrOptions: true,
            resGetPath: '/app/locales/__lng__/__ns__.json' + ((window.MD_TAG !== undefined) ? '?' + window.MD_TAG : ''),
            debug: false,
            cookieExpirationTime: 100000,
            cookieName: COOKIE_NAME,
            cookieDomain: getI18nCookieDomain(),
            lngWhitelist: appLangs
        };
    };
    var getI18nCookieDomain = function () {
        return Config.i18nCookieDomain;
    };


    var i18nHelper = {
        init: function (callback) {
            var self = this;
            i18n.init(getI18nConfig()).done(function () {
                currentLang = self.checkCurrentLang();
                if (callback) {
                    callback();
                }
            }).fail(function (err){
                if(err)console.log('err', err);
            });
        },
        checkCurrentLang: function () {
            var lang = i18n.lng() || DEFAULT_LANG;
            lang = lang.substring(0, 2);

            if (!_.contains(appLangs, lang)) {
                lang = DEFAULT_LANG;
            }

            return lang;
        },

        getCurrentLang: function () {
            return currentLang;
        },
        getI18nConfig: function () {
            return getI18nConfig();
        }

    };

    return i18nHelper;
});

